// 所有协议统一控制
export const TOGGLE_AGREEMENT = 'TOGGLE_AGREEMENT'

// 联系我们
export const TOGGLE_CONCAT_US = 'TOGGLE_CONCAT_US'

// 关于我们
export const TOGGLE_ABOUT_US = 'TOGGLE_ABOUT_US'

// 下单成功
export const TOGGLE_ORDER_SUCCESS = 'TOGGLE_ORDER_SUCCESS'

export const BURY_CODE = 'BURY_CODE'
